import React from "react";
import FooterComponent from "../Footer/footer.component";
import HeaderComponent from "../Header/header.component";

const BomListComponent = () => {
  return (
    <>
    {/* <HeaderComponent /> */}
    <div>
      <div className="ClsBreadcrumb d-flex align-items-center">
        <div className="container position-relative">
          <div className="clsPjtitle">
            <div className="PTitle row">
              <div className="col-lg-9 d-flex flex-column">
                <h3>project name</h3>
              </div>
              <div className="col-lg-3 d-flex flex-column">
                <label>
                  Total Number Of Boards :{" "}
                  <img src="assets/img/edit.png" alt="Blue Icon" />
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <main className="main">
        <section id="Projname" className="Projname section">
          <div className="container">
            <div className="ClsDescrip">
              <div className="">
                <div className="row Proj-top">
                  <div className="col-lg-12 LBlock" data-aos="fade-up" data-aos-delay="100">
                    <div className="">
                      <div className="Productinfo">
                        {/* Tabular */}
                        <div className="ClsCTable">
                          <div className="PTabular">
                            <div className="row">
                              <table>
                                <thead>
                                  <tr className="titles">
                                    <th className="clsptext">No.</th>
                                    <th className="clsptext">MPN</th>
                                    <th className="clsptext">Unit Qty</th>
                                    <th className="clsptext">Required Qty</th>
                                    <th className="clsptext">Order Qty</th>
                                    <th className="clsptext">Unit Price</th>
                                    <th className="clsptext">Extended Price</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {[...Array(8)].map((_, index) => (
                                    <tr key={index}>
                                      <td className="clsptext">{String(index + 1).padStart(2, "0")}</td>
                                      <td className="clsptext">
                                        <img
                                          src="assets/img/green-icon.png"
                                          alt="Green Icon"
                                        />
                                        2450AT18B100E
                                      </td>
                                      <td className="clsptext">200</td>
                                      <td className="clsptext">800</td>
                                      <td className="clsptext">800</td>
                                      <td className="clsptext">₹33.87</td>
                                      <td className="clsptext greentxt">₹270988.87</td>
                                    </tr>
                                  ))}
                                  <tr>
                                    <td className="clsptext">07</td>
                                    <td className="clsptext">
                                      <img
                                        src="assets/img/green-icon.png"
                                        alt="Green Icon"
                                      />
                                      2450AT18B100E
                                    </td>
                                    <td className="clsptext">200</td>
                                    <td className="clsptext">800</td>
                                    <td className="clsptext redtext">0</td>
                                    <td className="clsptext redtext">No Component</td>
                                    <td className="clsptext redtext">No Component</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                        {/* Tabular */}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row Proj-bottom">
                  <div className="col-lg-8 RBlock d-flex flex-column" data-aos="fade-up" data-aos-delay="200">
                    <ul>
                      <li>
                        <img
                          src="assets/img/green-icon.png"
                          alt="Green Icon"
                        />
                        : Component Available
                      </li>
                      <li>
                        <img
                          src="assets/img/red-icon.png"
                          alt="Red Icon"
                        />
                        : Component Not Available
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-4 RBlock d-flex flex-column" data-aos="fade-up" data-aos-delay="200">
                    <div className="CSummary">
                      <div className="ClsChead">
                        <h4>Summary</h4>
                      </div>
                      <table className="ClsCSTable">
                        <tbody>
                          <tr className="ClsCtext">
                            <td>Per Board Cost</td>
                            <td>₹ 5,08,602.76</td>
                          </tr>
                          <tr className="ClsCtext">
                            <td>Total Kit Cost</td>
                            <td>₹ 5,08,602.76</td>
                          </tr>
                          <tr className="ClsCtext">
                            <td>Shipping charges</td>
                            <td>₹ 200</td>
                          </tr>
                          <tr className="ClsCtext">
                            <td>Subtotal</td>
                            <td>₹ 5,08,602.76</td>
                          </tr>
                          <tr className="ClsCtext">
                            <td>GST</td>
                            <td>₹ 91,548.50</td>
                          </tr>
                          <tr className="ClsCTotal">
                            <td>Grand Total</td>
                            <td>₹ 6,00,151</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
    {/* <FooterComponent /> */}
    </>
  );
};

export default BomListComponent;
